/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import MultimediaEmbeddedVideoItem from '../../common/PressReleaseWrittenContent/MultimediaEmbeddedVideoItem';
import MultimediaImageVideoItem from '../../common/PressReleaseWrittenContent/MultimediaImageVideoItem';
import MultimediaPdfItem from '../../common/PressReleaseWrittenContent/MultimediaPdfItem';

const MediaGallery = ({ cloudinaryCloudName, multimediaAddOns }) => {
  return (
    <div className="multimedia-add-ons">
      <div className="multimedia-add-ons__header">Media gallery</div>
      {multimediaAddOns.map((media) => {
        const displayObject = {
          caption: media.caption,
          publicId: media.cloudinary_public_id,
          multimediaAddOnId: media.multimedia_add_on_id,
          fileName: media.file_name,
          mediaType: media.media_type,
          videoEmbedHtml: media.embedded_video_html,
        };
        return (
          <div className="multimedia-add-ons__wrapper" key={media.file_name}>
            {media.media_type === 'embedded_video' && <MultimediaEmbeddedVideoItem mediaProperties={displayObject} key={media.file_name} />}
            {media.media_type === 'pdf' && (
              <MultimediaPdfItem cloudinaryCloudName={cloudinaryCloudName} mediaProperties={displayObject} key={media.file_name} />
            )}
            {media.media_type !== 'embedded_video' && media.media_type !== 'pdf' && (
              <MultimediaImageVideoItem cloudinaryCloudName={cloudinaryCloudName} mediaProperties={displayObject} key={media.file_name} />
            )}
          </div>
        );
      })}
    </div>
  );
};

MediaGallery.propTypes = {
  multimediaAddOns: PropTypes.arrayOf(
    PropTypes.shape({
      caption: PropTypes.string.isRequired,
      cloudinary_public_id: PropTypes.string,
      file_name: PropTypes.string,
      id: PropTypes.number.isRequired,
      media_type: PropTypes.string.isRequired,
      secure_url: PropTypes.string,
      embedded_video_html: PropTypes.string,
    }),
  ).isRequired,
  cloudinaryCloudName: PropTypes.string.isRequired,
};

export default MediaGallery;
